module.exports = "./img/ad17a467357ceb92b6e6d13bfcfdb88c.jpg";